// Import React library for creating the component
import React from "react";
// Import the CSS for button styling
import "../../css/Button.css";

/**
 * ButtonSecondary component for rendering a secondary styled button.
 *
 * Props:
 * - text: The button label (string)
 * - variant: Button style variant (e.g., 'primary', 'secondary')
 * - onClick: Click handler function
 * - className: Additional CSS classes
 * - type: Button type (e.g., 'button', 'submit')
 * - ...props: Any other props passed to the button
 */
const ButtonSecondary = ({
  text, // Button label
  variant = "primary", // Style variant
  onClick, // Click event handler
  className = "", // Additional CSS classes
  type = "button", // Button type
  ...props // Other props
}) => {
  return (
    <button
      type={type}
      className={`pf-button secondary pf-button-${variant} ${className}`}
      onClick={onClick}
      {...props}
    >
      {/* Button content styled with content-semibold class */}
      <div className="content-semibold">{text}</div>
    </button>
  );
};

// Export the ButtonSecondary component as default
export default ButtonSecondary;
